import { h } from 'preact';

export const LeftArrowIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M14.25 9H3.75" stroke="#262626" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M9 14.25L3.75 9L9 3.75" stroke="#262626" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	);
};
